import * as React from 'react';
import { RecipientsWrapper } from './styles';
import Tabs from './tabs';
import EvaluateDonor from '../match/evaluate-donor';
import Recipient from '../center-admin/recipient';
import EvaluateMatch from '../match/index';
import EvaluateRecipientDonor from '../match/evaluate-recipient-donor';
import EvaluateRexm from '../match/evaluate-rexm';
import PotentialDonors from './potential-donors';
import DonorPreselect from './donor-pre-select';
import RsEnroll from './rs-enroll';
import RecipientShieldList from './recipient-shield';
import ImportWaitlist from './import-waitlist';
import VoucherHolders from '../voucher-holder/list';
import VoucherHolderAddEdit from '../voucher-holder/add-edit';
import RecipientList from './list/center';
import RecipientProfile from './profile';
import RecipientToolbox from '../recipient/toolbox';
import RecipientEmpletMM from '../recipient/eplet-mismatch';
import RecipientDonorFactSheet from '../recipient/donor-fact-sheet';
import WaitlistReplace from '../recipient/waitlist-replace';
import CenterList from './patient-intake/list/center-list';
import TransplantedRecipientList from './transplanted-recipients';
import { FileDocumentType } from '@nkr/enums/document-type';
import { PatientIntakeTabs } from './patient-intake/list/nav';

interface IProps {
    centerId: number,
    centerAlias: string,
    section: string,
    subSection: string,
    recipientId?: number,
    donorId?: number,
    rexmId?: number,
    matchHistoryId?: number,
    voucherHolderId?: number,
    hasRecipientShield: boolean,
    isAdmin: boolean,
    isAdminLogin: boolean,
    downloadFormsAndChecklist: (donorId: number, recipientId: number) => void,
    onGetFile: (docType: FileDocumentType, donorId: number) => void
}

const Recipients = (props: IProps) => {
    const [recipientAlias, setRecipientAlias] = React.useState('');
    const [isTransplanted, setIsTransplanted] = React.useState(false);

    const handleUpdateRecipientAlias = (recipientAlias: string, isTransplanted?: boolean) => {
        setRecipientAlias(recipientAlias);
        setIsTransplanted(isTransplanted);
    }

    const section = props.section.toUpperCase();

    return (
        <RecipientsWrapper>
            {section != 'VOUCHER-HOLDER-EDIT' && (
                <Tabs
                    activeKey={props.section}
                    centerId={props.centerId}
                    recipientId={props.recipientId}
                    recipientAlias={recipientAlias}
                    hasRecipientShield={props.hasRecipientShield}
                    isAdmin={false}
                    onTabSelect={() => null}
                />
            )}

            {section == 'RECIPIENT-WAIT-LIST' && (
                <div className='recipient-section'>
                    <Recipient
                        subSection={props.subSection}
                        centerAlias={props.centerAlias}
                        centerId={props.centerId}
                    />
                </div>
            )}

            {section == 'DONOR-PRE-SELECT' && (
                <div className='recipient-section'>
                    <DonorPreselect
                        centerId={props.centerId}
                    />
                </div>
            )}

            {section == 'RECIPIENT-SHIELD' && (
                <div className='recipient-section'>
                    <RecipientShieldList
                        centerId={props.centerId}
                    />
                </div>
            )}

            {section == 'TRANSPLANTED-RECIPIENTS' && (
                <div className='recipient-section'>
                    <TransplantedRecipientList
                        centerId={props.centerId}
                    />
                </div>
            )}

            {section == 'RS-ENROLL' && (
                <div className='recipient-section'>
                    <RsEnroll
                        recipientId={props.recipientId}
                        centerId={props.centerId}
                    />
                </div>
            )}

            {section == 'POTENTIAL-DONORS' && (
                <div className='recipient-section'>
                    <PotentialDonors
                        recipientId={props.recipientId}
                        centerId={props.centerId}
                        onUpdateRecipientAlias={handleUpdateRecipientAlias}
                    />
                </div>
            )}

            {section == 'EVALUATE-MATCH' && (
                <div className='recipient-section'>
                    <EvaluateMatch
                        centerId={props.centerId}
                        recipientId={props.recipientId}
                        donorId={props.donorId}
                        matchHistoryId={props.matchHistoryId}
                        onUpdateRecipientAlias={handleUpdateRecipientAlias}
                    />
                </div>
            )}

            {section == 'EVALUATE-RECIPIENT-DONOR' && (
                <div className='recipient-section'>
                    <EvaluateRecipientDonor
                        centerId={props.centerId}
                        recipientId={props.recipientId}
                        donorId={props.donorId}
                        onUpdateRecipientAlias={handleUpdateRecipientAlias}
                        onDownloadFormsAndChecklist={props.downloadFormsAndChecklist}
                    />
                </div>
            )}

            {section == 'EVALUATE-REXM' && (
                <div className='recipient-section'>
                    <EvaluateRexm
                        centerId={props.centerId}
                        recipientId={props.recipientId}
                        rexmId={props.rexmId}
                        onUpdateRecipientAlias={handleUpdateRecipientAlias}
                        onGetFile={props.onGetFile}
                    />
                </div>
            )}

            {section == 'EVALUATE-DONOR' && (
                <div className='recipient-section'>
                    <EvaluateDonor
                        centerId={props.centerId}
                        recipientId={props.recipientId}
                        donorId={props.donorId}
                        onUpdateRecipientAlias={handleUpdateRecipientAlias}
                    />
                </div>
            )}

            {section == 'IMPORT-WAITLIST' && (
                <div className='recipient-section'>
                    <ImportWaitlist centerId={props.centerId} />
                </div>
            )}

            {section == 'VOUCHER-HOLDERS' && (
                <div className='recipient-section'>
                    <VoucherHolders
                        centerId={props.centerId}
                        isAdmin={false}
                        isAdminLogin={false}
                    />
                </div>
            )}

            {section == 'VOUCHER-HOLDER-EDIT' && (
                <div>
                    <VoucherHolderAddEdit
                        voucherHolderId={props.voucherHolderId}
                        centerId={props.centerId}
                        donorId={0}
                        isAdmin={props.isAdmin}
                        isAdminLogin={props.isAdminLogin}
                    />
                </div>
            )}

            {section == 'RECIPIENT-PROFILE' && (
                <div className='recipient-section'>
                    <RecipientProfile
                        centerId={props.centerId}
                        recipientId={props.recipientId}
                        section={props.subSection}
                        onUpdateRecipientAlias={handleUpdateRecipientAlias}
                    />
                </div>
            )}

            {section == 'RECIPIENT-LIST' && (
                <div className='recipient-section'>
                    <RecipientList
                        centerId={props.centerId}
                        recipientId={0}
                    />
                </div>
            )}

            {section == 'TOOLBOX' && (
                <div className='recipient-section'>
                    <RecipientToolbox
                        recipientId={props.recipientId}
                        centerId={props.centerId}
                        onUpdateRecipientAlias={handleUpdateRecipientAlias}
                    />
                </div>
            )}

            {section == 'EPLET-MM' && (
                <div className='recipient-section'>
                    <RecipientEmpletMM
                        recipientId={props.recipientId}
                        donorId={props.donorId}
                        centerId={props.centerId}
                    />
                </div>
            )}

            {section == 'DONOR-FACT-SHEET' && (
                <div className='recipient-section'>
                    <RecipientDonorFactSheet
                        recipientId={props.recipientId}
                        donorId={props.donorId}
                        centerId={props.centerId}
                    />
                </div>
            )}

            {section == 'WAITLIST-REPLACE' && (
                <WaitlistReplace
                    centerId={props.centerId}
                    recipientId={props.recipientId}
                />
            )}

            {section == 'PATIENT-INTAKE-LIST' && (
                <div className='recipient-section'>
                    <CenterList
                        centerId={props.centerId}
                        tab={props.subSection as PatientIntakeTabs} />
                </div>
            )}

            {section == 'DONOR-SHIELD-DIRECT' && (
                <div className='recipient-section'>
                    <div style={{ padding: '10px 5px 20px 10px' }}>
                        <div>NEW STUFF!</div>
                    </div>
                </div>
            )}
        </RecipientsWrapper>
    );
}

export default Recipients;